import React from 'react';
import { Helmet } from 'react-helmet-async';
import SEOSchema from '../components/SEOSchema';
import { homeFaqs } from '../data/mock';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AnnouncementBanner from '../components/AnnouncementBanner';
import FloatingWhatsApp from '../components/FloatingWhatsApp';
import MobileBottomNav from '../components/MobileBottomNav';
import ExitIntentPopup from '../components/ExitIntentPopup';
import AccessibilityFab from '../components/AccessibilityFab';

import HeroSection from '../components/landing/HeroSection';
import CredibilityStrip from '../components/landing/CredibilityStrip';
import NotGenericSection from '../components/landing/NotGenericSection';
import ProblemSection from '../components/landing/ProblemSection';
import WhyTCubeSection from '../components/landing/WhyTCubeSection';
import ProgramsSection from '../components/landing/ProgramsSection';
import HubCardsSection from '../components/landing/HubCardsSection';
import MedicalTeamSection from '../components/landing/MedicalTeamSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import ReviewsTeaserSection from '../components/landing/ReviewsTeaserSection';
import FAQSection from '../components/landing/FAQSection';
import EmailCaptureSection from '../components/landing/EmailCaptureSection';
import InstagramSection from '../components/landing/InstagramSection';
import ConsultationSection from '../components/landing/ConsultationSection';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Helmet>
        <title>Doctor-Led Nutrition &amp; Fitness Programs | Diabetes, Weight &amp; Metabolic Health | TCUBE FITNESS™</title>
        <meta name="description" content="Doctor-led, personalized nutrition and fitness, built around your health. Clinical nutrition for diabetes, weight management, metabolic and women's health, led by a General Medicine (Internal Medicine) physician. 100% online across India." />
        <link rel="canonical" href="https://tcubefitness.com/" />
      </Helmet>

      <SEOSchema
        type="organization"
        name="TCUBE FITNESS™"
        description="Doctor-led online programs for fertility, pregnancy, postpartum and clinical nutrition. Personalized, medically supervised, and evidence-based."
        url="/"
        breadcrumbs={[{ name: 'Home', path: '/' }]}
        faq={homeFaqs}
      />

      {/* Skip to main content - accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[80] focus:bg-blue-600 focus:text-white focus:px-4 focus:py-2 focus:rounded-md focus:outline focus:outline-2 focus:outline-white"
        data-testid="skip-to-main-link"
      >
        Skip to main content
      </a>

      <AnnouncementBanner />
      <Header />

      <main id="main-content" tabIndex={-1}>
        <HeroSection />
        <CredibilityStrip />
        <ProblemSection />
        <WhyTCubeSection />
        <NotGenericSection />
        <ProgramsSection />
        <HubCardsSection />
        <MedicalTeamSection />
        <HowItWorksSection />
        <ReviewsTeaserSection />
        <ConsultationSection />
        <FAQSection />
        <EmailCaptureSection />
        <InstagramSection />
      </main>

      <Footer />
      <FloatingWhatsApp />
      <MobileBottomNav />
      <ExitIntentPopup />
      <AccessibilityFab />
    </div>
  );
};

export default LandingPage;
